import React from "react"
import { useHistory } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
import CloudUploadIcon from "@material-ui/icons/CloudUpload"
import HomeIcon from "@material-ui/icons/Home"
import BarChartIcon from "@material-ui/icons/BarChart"
import MoreHorizIcon from "@material-ui/icons/MoreHoriz"
import WhiteLogo from "../assets/images/logo/white_logo.png"
import { getLoggedInUserDisplayName } from "../v2_actions/auth"
import { getInitials } from "../v2_actions/photographer"

export const MobileComingSoon = () => {
    const classes = useStyles()
    const history = useHistory()
    const displayName = getLoggedInUserDisplayName()
    const initials = getInitials(displayName)

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <img src={WhiteLogo} alt="bossfotos" className={classes.logo} />
                <div className={classes.avatar}>{initials}</div>
            </div>
            <div className={classes.content}>
                <CloudUploadIcon className={classes.icon} />
                <div className={classes.title}>Coming Soon</div>
                <div className={classes.subtitle}>This feature is currently under development</div>
            </div>
            <div className={classes.bottomNav}>
                <div className={classes.navItem} onClick={() => history.push("/photographer/map")}>
                    <HomeIcon className={classes.navIcon} />
                    <span className={classes.navLabel}>Home</span>
                </div>
                <div className={classes.navItem} onClick={() => history.push("/photographer/mobile-sales")}>
                    <BarChartIcon className={classes.navIcon} />
                    <span className={classes.navLabel}>Sales</span>
                </div>
                <div className={classes.navItem}>
                    <CloudUploadIcon className={classes.navIconActive} />
                    <span className={classes.navLabelActive}>Upload</span>
                </div>
                <div className={classes.navItem}>
                    <MoreHorizIcon className={classes.navIcon} />
                    <span className={classes.navLabel}>More</span>
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        fontFamily: "Helvetica, Raleway, sans-serif",
        paddingBottom: "60px",
    },
    header: {
        background: "linear-gradient(135deg, #0d2137 0%, #1e88e5 100%)",
        padding: "16px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    logo: {
        height: "36px",
        width: "auto",
    },
    avatar: {
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        backgroundColor: "#1565c0",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "13px",
        fontWeight: 600,
        border: "2px solid #fff",
    },
    content: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
    },
    icon: {
        fontSize: "64px",
        color: "#1e88e5",
        marginBottom: "24px",
    },
    title: {
        fontSize: "24px",
        fontWeight: 700,
        color: "#333",
        marginBottom: "8px",
    },
    subtitle: {
        fontSize: "14px",
        color: "#999",
    },
    bottomNav: {
        backgroundColor: "#fff",
        borderTop: "1px solid #e0e0e0",
        padding: "8px 0",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
    },
    navItem: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        padding: "4px 12px",
    },
    navIcon: {
        fontSize: "24px",
        color: "#0d2137",
        marginBottom: "2px",
    },
    navIconActive: {
        fontSize: "24px",
        color: "#1e88e5",
        marginBottom: "2px",
    },
    navLabel: {
        fontSize: "10px",
        color: "#0d2137",
    },
    navLabelActive: {
        fontSize: "10px",
        color: "#1e88e5",
        fontWeight: 600,
    },
})
